import axios from "@/index";
const material = {
  state: {
    baseDataMaterialList: [],
    materialData: []
  },
  getters: {},
  actions: {
    getBaseDataMaterialList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setBaseDataMaterialList",
                (state, { baseDataMaterialList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getMaterialInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setMaterialInfo",
                (state, { materialData: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setBaseDataMaterialList(state, action) {
      state.baseDataMaterialList = action.baseDataMaterialList;
    },
    setMaterialInfo(state, action) {
      state.materialData = action.materialData;
    }
  }
};
export default material;
